/**
 * Optional admin API token (set REACT_APP_ADMIN_TOKEN at build time).
 * Matches backend ADMIN_API_TOKEN: header X-Admin-Token for fetch; query admin_token for EventSource.
 */
function adminToken() {
  const t =
    typeof process !== 'undefined' && process.env && process.env.REACT_APP_ADMIN_TOKEN
      ? String(process.env.REACT_APP_ADMIN_TOKEN).trim()
      : '';
  return t;
}

export function adminFetchInit(init = {}) {
  const headers = new Headers(init.headers || {});
  const tok = adminToken();
  if (tok) headers.set('X-Admin-Token', tok);
  return { ...init, headers, credentials: init.credentials ?? 'include' };
}

export function adminStreamUrl(baseUrl, pathAndQuery) {
  const tok = adminToken();
  if (!tok) return `${baseUrl}${pathAndQuery}`;
  const sep = pathAndQuery.includes('?') ? '&' : '?';
  return `${baseUrl}${pathAndQuery}${sep}admin_token=${encodeURIComponent(tok)}`;
}
